import React from "react";

const Modal = ({ showing, close, children }) => (
  <div className={`modal ${showing ? "is-active" : ""}`}>
    <div className="modal-background" onClick={() => close()} />
    <div className="modal-card">
      <div className="modal-card-body">
        <div className="columns is-multiline">
          <div className="column is-12 has-text-right">
            <span className="close" onClick={() => close()}>
              close
            </span>
          </div>
          <div className="column is-12">{children}</div>
        </div>
      </div>
    </div>
  </div>
);

export default Modal;
